import {
	GetDepositPromotionRequest,
	GetDepositPromotionResponse,
} from '@/modules/promotion/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { DepositPromotionQueryKeys } from '@/modules/promotion/keys'
import { getDepositPromotionList } from '../../services'

export default function useQueryGetDepositPromotion(
	payload: GetDepositPromotionRequest,
	props?: UseBaseQueryOptions<GetDepositPromotionResponse>,
) {
	return useQuery({
		queryKey: [DepositPromotionQueryKeys.GetDepositPromotionList, payload],
		queryFn: () => getDepositPromotionList(payload),
		...props,
	})
}
